import { signInWithPopup, signOut, onAuthStateChanged } from 'firebase/auth';
import { auth, googleProvider } from '../firebase';

export const authService = {
  async signInWithGoogle() {
    try {
      googleProvider.addScope('email');
      googleProvider.addScope('profile');
      const result = await signInWithPopup(auth, googleProvider);
      return result.user;
    } catch (error) {
      throw new Error(error.message || 'Failed to sign in with Google');
    }
  },

  async signOut() {
    try {
      await signOut(auth);
    } catch (error) {
      throw new Error(error.message || 'Failed to sign out');
    }
  },

  onAuthStateChanged(callback) {
    return onAuthStateChanged(auth, callback);
  },

  async getCurrentUserToken() {
    const user = auth.currentUser;
    if (user) {
      return await user.getIdToken();
    }
    return null;
  },

  getCurrentUser() {
    return auth.currentUser;
  }
}; 